module.exports = __webpack_public_path__ + "static/stamp-3558bb108cf7c750b1144a6ee3a6ad93.svg";